import React, { useContext, useState, useEffect } from "react";
import { ApiContext } from "../apiContext";
import { FaEdit, FaTrashAlt, FaCog  } from "react-icons/fa";
import Service from "./Service";
import axios from "axios";
import { getToken } from "../../auth/AuthService";
import DeleteBox from "../DeleteBox";
import { useLoader } from "../../helper/Loader";
import notify from "../../helper/Notify";
import Permission from "./Permission";

function UserManagementApi({ page = 1, pageSize, searchQuery, totalLength }) {
  const { data, setData, error } = useContext(ApiContext);
  const {setIsLoader} = useLoader();
  const [filteredBlog, setFilteredBlog] = useState([]);
  const [showModal, setshowModal] = useState(false);
  const [EditModal, setEditModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const token = getToken();
  const closeModal = () => setshowModal(false);
  const modalClose = () => setEditModal(false);
  const apiBaseUrl = window.API_CONFIG.All_Api.users;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteCandidate, setDeleteCandidate] = useState(null);

  useEffect(() => {
    try {
      if (!data.users || data.users.length === 0) {
        throw new Error("No data available");
      }

      const filteredData = data.users.filter((item) => {
        const name = item?.name ?? "";
        return name.toLowerCase().includes(searchQuery.toLowerCase());
      });

      const sortedData = filteredData.sort(
        (a, b) =>
          {
            const dateA = a.updatedDate ? new Date(a.updatedDate) : new Date(a.createdDate);
            const dateB = b.updatedDate ? new Date(b.updatedDate) : new Date(b.createdDate);
            return dateB - dateA; 
      }
      );

      setFilteredBlog(sortedData);
      totalLength(filteredData.length);
    } catch (error) {
      console.error("Error fetching or processing data:", error);
    }
  }, [data.users, searchQuery, page, pageSize, totalLength]);

  /* Handle Remove function */
  const closeDelModal = () => setShowDeleteModal(false);

  const performDelete = async () => {
    closeDelModal();
    setIsLoader(true);

    try {
      const updatedCareerData = data.users.filter(
        (item) => item.code !== deleteCandidate.code
      );

      const response = await axios.post(
        apiBaseUrl,
        updatedCareerData,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": token,
          },
        }
      );
      console.log(response);
      setData((prevData) => ({
        ...prevData,
        users: updatedCareerData,
      }));

      notify.success("Data removed successfully");
    } catch (error) {
      console.error("Error removing data:", error);
      notify.error("Error removing data");
    }
    setIsLoader(false);
  };

  const handleRemover = (dataToRemove) => {
    setShowDeleteModal(true);
    setDeleteCandidate(dataToRemove);
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else {
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;

    const items = filteredBlog
      .slice(startIndex, endIndex)
      .map((viewModel, index) => {
        const id = `item-${index}`;
        const fetchData = async () => {
          try {
            setModalData(viewModel);
          } catch (error) {
            // Handle any errors that occur during the fetch
            console.error(error);
          }
        };
        return (
          <tr key={id}>
            {/* <td
              title="View"
              onClick={() => {
                setshowModal(true);
                fetchData();
              }}
            >
              <FaEye />
            </td> */}
            <td
              title="Edit"
              onClick={() => {
                setEditModal(true);
                fetchData();
              }}
            >
              <FaEdit />
            </td>

                 <td width="10%"
              title="pemrission"
              onClick={() => {
                setshowModal(true);
                fetchData();
              }}
            >
              <FaCog />
            </td>
            <td title="Delete" onClick={() => handleRemover(viewModel)}>
              <FaTrashAlt />
            </td>
            <td title={viewModel.name} width="15%">
              {viewModel && viewModel.name
                ? `${viewModel.name.substring(0, 40)}...`
                : "Name not available"}
            </td>
            <td title={viewModel.emailId} width="25%">
              {viewModel && viewModel.emailId
                ? `${viewModel.emailId.substring(0, 40)}...`
                : "Email not available"}
            </td>

        <td title={viewModel.password} width="15%">
  {viewModel && viewModel.password ? (
    `${atob(viewModel.password).substring(0, 40)}...`
  ) : (
    "Password not available"
  )}
</td>

            <td title={viewModel.role} width="15%">
              {viewModel && viewModel.role
                ? `${viewModel.role.substring(0, 40)}...`
                : "Role not assigned"}
            </td>           
             <td width="16%">
              {new Date(viewModel.updatedDate || viewModel.createdDate)
                .toISOString()
                .slice(0, 10)}
            </td>
            <td width="10%">
              <span
                className={`status ${viewModel.status ? "active" : "inactive"}`}
              >
                {viewModel.status ? "active" : "inactive"}
              </span>
            </td>
            {showModal && (
              <Permission Modalclose={closeModal} modalData={modalData}  setModalData={setModalData} />
            )}
            {EditModal && (
              <Service
                closeModal={modalClose}
                modalData={modalData}
                setModalData={setModalData}
              />
            )}
          </tr>
        );
      });

    const caseItems = (
      <tbody>
        {filteredBlog.length === 0 ? (
          <tr>
          <td classname ="noFound" colSpan="12">No data found</td>
          </tr>
        ) : (
          items
        )}
        {showDeleteModal && (
          <DeleteBox Modalclose={closeDelModal} handleDelete={performDelete} />
        )}
      </tbody>
    );
    return caseItems;
  }
}
export const UserLength = () => {
  const { data } = useContext(ApiContext);
  return data.users.length;
};

export default UserManagementApi;
